import { HttpResponse } from '@capacitor/core';
import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

/**
 * Set Firestore Message Token in database
 */
export const setUserDeviceFCMToken = async (userId: string | undefined, deviceToken: string): Promise<void> => {
  if (!userId) return;

  await HttpHandler({
    method: 'POST',
    url: `${environment.CLIENT_URL}/devices/${userId}`,
    data: {
      userDeviceToken: deviceToken,
    },
  });
};

/**
 * Function to notify psychologists about user entered the chat
 * @param userId string
 * @param psychologistId string
 * @return Promise<void>
 */
export const notifyAboutJoinToTheVideoChat = async (userId: string, psychologistId: string): Promise<HttpResponse> => {
  const requestURL = environment.CF_NOTIFY_WHEN_JOIN_TO_CHAT;

  return HttpHandler({
    method: 'POST',
    data: {
      user_id: userId,
      psychologist_id: psychologistId,
    },
    url: requestURL,
  });
};
